var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticStyle:{"height":"100vh","margin-left":"56px","display":"flex","flex-direction":"row","padding":".4vh","align-items":"center"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }